import { Controller } from "@hotwired/stimulus"

export default class AutoDownloadController extends Controller {
  static values = { url: String, delay: Number }

  connect() {
    setTimeout(() => {
      this.initiateDownload()
    }, this.delayValue || 1000)
  }

  initiateDownload() {
    const downloadIframe = document.createElement("iframe")
    downloadIframe.style.display = "none"
    downloadIframe.src = this.urlValue
    document.body.appendChild(downloadIframe)
  }
}
